import type { FaireProductEntity } from "../../entity_types/product";

export const casa_bosques_6: FaireProductEntity = {
  token: "casa-bosques-6",
  type: "product",
  name: "Sardinha Yellow Package",
  brandName: "Casa Bosques",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/259c9bd199b6fd0a69541bf48e154c8fc3c2fac8e7d39aa616b37fce6a955d32.webp",
  priceDollars: 12,
  msrpDollars: 20,
  freeShipping: true,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
